module.exports = __webpack_public_path__ + "static/women-on-rocket-on-blob-c1d10f45f6776cff870ed397ac213492.jpg";